import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../lib/hooks.ts';

export default function Footer() {
    const {t} = useTranslation("footer");
    const config = useAppSelector(state => state.config.config)

    function deploymentDate() {
        if (config === undefined)
            return ""

        const date = DateTime.fromISO(config.deployment.date)
        return date.toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS)
    }

    const deploymentInfo = `${config?.deployment.env} (${deploymentDate()} - ${config?.deployment.image})`

    return (
        <div className="gradient">
            <div
                className="max-w-screen-xl flex flex-col md:flex-row flex-wrap md:items-center justify-between mx-auto p-12 md:p-8 gap-y-8 text-white">
                <div>
                    <h3 className="text-lg font-semibold">{t('alfa1Officedays')}</h3>
                    <small className="text-gray-300">{deploymentInfo}</small>
                </div>
                <div>
                    <h3 className="text-lg font-semibold mb-2">links</h3>
                    <div className="flex flex-col md:flex-row flex-wrap gap-2 text-sm mb-2 max-w-full md:max-w-72">
                        <a href="https://www.alfa1.com/privacy" target="_blank" className="hover:underline text-white">{t('privacyStatement')}</a>
                    </div>
                </div>
            </div>
        </div>
    )
}